import React from 'react';
import GitHubIcon from "@material-ui/icons/GitHub";

function Github() {
    return (
      <a href="https://github.com/harsh1206/COVID_TRACKER">
        <GitHubIcon />
      </a>
    );
}

export default Github
